/**
 * @param {Object} props
 * @param {string | undefined} [props.className]
 * @returns {React.ReactElement} The rendered component
 */
const PrintIcon = ({ className }) => (
  <svg
    className={className}
    id="Ebene_1"
    data-name="Ebene 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 374.29 396.73"
    width={32}
    height={30}
  >
    <path
      fill="currentColor"
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={10}
      d="M352.89,98.22H315.83V33.81a27.24,27.24,0,0,0-27.21-27.2H117.09a27.24,27.24,0,0,0-27.21,27.2V98.22H52.82a32.15,32.15,0,0,0-32.11,32.11V279.89A32.15,32.15,0,0,0,52.82,312H89.88v74.46a6.87,6.87,0,0,0,6.87,6.87H309a6.87,6.87,0,0,0,6.87-6.87V312h37.06A32.15,32.15,0,0,0,385,279.89V130.33A32.15,32.15,0,0,0,352.89,98.22ZM103.63,33.81a13.47,13.47,0,0,1,13.46-13.46H288.62a13.48,13.48,0,0,1,13.47,13.46V98.22H103.63ZM302.09,379.59H103.63V206.37H302.09Zm69.17-99.7a18.39,18.39,0,0,1-18.37,18.37H315.83V199.5a6.87,6.87,0,0,0-6.87-6.87H96.75a6.87,6.87,0,0,0-6.87,6.87v98.76H52.82a18.39,18.39,0,0,1-18.37-18.37V130.33A18.39,18.39,0,0,1,52.82,112H352.89a18.39,18.39,0,0,1,18.37,18.37Z"
      transform="translate(-15.71 -1.61)"
    />
    <path
      fill="currentColor"
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={10}
      d="M255.9,242.17H149.8a6.87,6.87,0,0,0,0,13.74H255.9a6.87,6.87,0,0,0,0-13.74Z"
      transform="translate(-15.71 -1.61)"
    />
    <path
      fill="currentColor"
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={10}
      d="M255.9,286.11H149.8a6.87,6.87,0,0,0,0,13.74H255.9a6.87,6.87,0,0,0,0-13.74Z"
      transform="translate(-15.71 -1.61)"
    />
    <path
      fill="currentColor"
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={10}
      d="M255.9,330H149.8a6.88,6.88,0,0,0,0,13.75H255.9a6.88,6.88,0,0,0,0-13.75Z"
      transform="translate(-15.71 -1.61)"
    />
    <path
      fill="currentColor"
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={10}
      d="M116.39,148.69H78.06a6.88,6.88,0,0,0,0,13.75h38.33a6.88,6.88,0,0,0,0-13.75Z"
      transform="translate(-15.71 -1.61)"
    />
  </svg>
);

export default PrintIcon;
